<base-app-loader [loading]="store.appLoader()" />
@if (loading) {
  <div class="tw-h-svh tw-flex tw-justify-center tw-items-center">
    <p>Please wait...</p>
  </div>
} @else {
  <router-outlet></router-outlet>
}
